export interface IBaseEvent {
    name: EventName;
}

export type IEvent =
    | IWindowResizedEvent
    | IUserProfileUpdatedEvent
    | IUserDepositedEvent
    | IUserWithdrewEvent
    | ILoginRequestedEvent
    | ILoginExecutedEvent
    | ILogoutRequestedEvent
    | ILogoutExecutedEvent
    | INavigatedEvent
    | IUploadDocumentKycAttemptEvent
    | IUploadDocumentKycSuccessEvent
    | IUploadDocumentKycFailedEvent
    | IRGSubmittedEvent;

export enum EventName {
    WINDOW_RESIZE = 'WindowResize',
    USER_PROFILE_UPDATE = 'UserProfileUpdate',
    USER_DEPOSIT = 'UserDeposit',
    USER_WITHDRAWAL = 'UserWithdrawal',
    LOGIN_REQUEST = 'LoginRequest',
    LOGIN_EXECUTED = 'LoginExecuted',
    LOGOUT_REQUEST = 'LogoutRequest',
    LOGOUT_EXECUTED = 'LogoutExecuted',
    NAVIGATE = 'Navigate',
    UPLOAD_DOCUMENT_KYC_ATTEMPT = 'UploadDocumentKycAttempt',
    UPLOAD_DOCUMENT_KYC_SUCCESS = 'UploadDocumentKycSuccess',
    UPLOAD_DOCUMENT_KYC_FAILED = 'UploadDocumentKycFailed',
    RG_SUBMITTED = 'RgSubmitted',
}

export interface IWindowResizedEvent extends IBaseEvent {
    name: EventName.WINDOW_RESIZE;
    width: number;
    height: number;
}

export interface IUserProfileUpdatedEvent extends IBaseEvent {
    name: EventName.USER_PROFILE_UPDATE;
}

export interface IUserDepositedEvent extends IBaseEvent {
    name: EventName.USER_DEPOSIT;
    amount: number;
    currency: string;
}

export interface IUserWithdrewEvent extends IBaseEvent {
    name: EventName.USER_WITHDRAWAL;
    amount: number;
    currency: string;
}

export interface ILoginRequestedEvent extends IBaseEvent {
    name: EventName.LOGIN_REQUEST;
}

export interface ILoginExecutedEvent extends IBaseEvent {
    name: EventName.LOGIN_EXECUTED;
}

export interface ILogoutRequestedEvent extends IBaseEvent {
    name: EventName.LOGOUT_REQUEST;
}

export interface ILogoutExecutedEvent extends IBaseEvent {
    name: EventName.LOGOUT_EXECUTED;
}

export interface INavigatedEvent extends IBaseEvent {
    name: EventName.NAVIGATE;
    path: string;
}

export interface IUploadDocumentKycAttemptEvent extends IBaseEvent {
    name: EventName.UPLOAD_DOCUMENT_KYC_ATTEMPT;
}

export interface IUploadDocumentKycSuccessEvent extends IBaseEvent {
    name: EventName.UPLOAD_DOCUMENT_KYC_SUCCESS;
}

export interface IUploadDocumentKycFailedEvent extends IBaseEvent {
    name: EventName.UPLOAD_DOCUMENT_KYC_FAILED;
}

export interface IRGSubmittedEvent extends IBaseEvent {
    name: EventName.RG_SUBMITTED;
    period: string;
}
